// Minimal Kith Header JavaScript
(function () {
    'use strict';

    /* Drawer motion lives in CSS custom properties; never re-hardcode it here. */
    function wcwyDrawerTiming() {
        if (window.WCWYDrawerController && window.WCWYDrawerController.timing) {
            return window.WCWYDrawerController.timing();
        }
        return { open: 360, close: 260, openSettle: 380, closeFallback: 340 };
    }

    /* Start the slide on a frame the browser has already painted. */
    function wcwyAfterPaint(fn) {
        if (window.WCWYDrawerController && window.WCWYDrawerController.afterPaint) {
            return window.WCWYDrawerController.afterPaint(fn);
        }
        return window.requestAnimationFrame(function () {
            window.requestAnimationFrame(fn);
        });
    }

    var kithHeader = {
        header: null,
        spacer: null,
        hero: null,
        searchTrigger: null,
        searchDropdown: null,
        searchOverlay: null,
        heroObserver: null,
        headerOffset: 0,
        productSolidThreshold: 0,
        isSolid: false,
        isHidden: false,
        heroInView: true,
        useScrollPosition: false,
        isProductPage: false,
        lastScrollTop: 0,
        hideThreshold: 80,
        scrollDelta: 4,
        _bound: false,
        _editorBound: false,
        _searchDocBound: false,
        _refreshQueued: false,
        _lastWrittenHeaderOffset: null,
        _hasAppliedSolidState: false,

        init: function () {
            this.header = document.getElementById('kith-header') || document.querySelector('[data-site-header]');
            this.spacer = document.querySelector('.kith-header-spacer');
            this.searchTrigger = document.querySelector('[data-search-trigger]');
            this.searchDropdown = document.querySelector('[data-search-dropdown]');
            this.searchOverlay = document.querySelector('[data-wcwy-search-overlay]');
            this.isProductPage = document.body.className.indexOf('product') > -1;

            if (!this.header) return;

            this.lastScrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
            this.isSolid = false;
            this.isHidden = false;
            this._hasAppliedSolidState = false;

            this.bindEvents();
            this.bindSearchEvents();
            this.refreshMeasurements();
            this.handleScroll();
        },

        bindEvents: function () {
            var self = this;

            if (!this._bound) {
                var scrollTicking = false;
                var resizeTicking = false;

                window.addEventListener('scroll', function () {
                    if (scrollTicking) return;

                    scrollTicking = true;
                    window.requestAnimationFrame(function () {
                        self.handleScroll();
                        scrollTicking = false;
                    });
                }, { passive: true });

                window.addEventListener('resize', function () {
                    if (resizeTicking) return;

                    resizeTicking = true;
                    window.requestAnimationFrame(function () {
                        self.refreshMeasurements();
                        resizeTicking = false;
                    });
                }, { passive: true });

                window.addEventListener('load', function () {
                    self.refreshMeasurements();
                }, { once: true });

                this._bound = true;
            }

            if (!this._editorBound && typeof Shopify !== 'undefined' && Shopify.designMode) {
                document.addEventListener('shopify:section:load', function () {
                    self.init();
                });
                this._editorBound = true;
            }

        },


        bindSearchEvents: function () {
            var self = this;

            if (!this.searchOverlay && this.searchDropdown) {
                var triggers = document.querySelectorAll('[data-search-trigger]');
                for (var i = 0; i < triggers.length; i++) {
                    if (!triggers[i].dataset.kithSearchBound) {
                        triggers[i].dataset.kithSearchBound = 'true';
                        (function (trigger) {
                            trigger.addEventListener('click', function (event) {
                                event.preventDefault();
                                self.toggleSearch();
                            });
                        })(triggers[i]);
                    }
                }
            }

            if (!this._searchDocBound) {
                document.addEventListener('click', function (event) {
                    if (!self.searchDropdown || self.searchOverlay) return;
                    var allTriggers = document.querySelectorAll('[data-search-trigger]');
                    for (var i = 0; i < allTriggers.length; i++) {
                        if (allTriggers[i].contains(event.target)) return;
                    }
                    if (self.searchDropdown.contains(event.target)) return;
                    self.closeSearch();
                });

                this._searchDocBound = true;
            }
        },

        readHeaderOffset: function () {
            if (!this.header) return 0;

            var rect = this.header.getBoundingClientRect();
            return Math.round(rect.height || this.header.offsetHeight || 0);
        },

        readProductThreshold: function (headerOffset) {
            if (!this.isProductPage) return 0;

            var gallery = document.querySelector('.product-lv-gallery');
            if (!gallery) {
                return Math.round(window.innerHeight * 0.55);
            }

            return Math.max(0, gallery.offsetHeight - headerOffset);
        },

        writeHeaderOffset: function (headerOffset) {
            if (this._lastWrittenHeaderOffset !== headerOffset) {
                document.documentElement.style.setProperty('--kith-header-offset', headerOffset + 'px');
                this._lastWrittenHeaderOffset = headerOffset;
            }

            if (this.spacer) {
                var spacerHeight = headerOffset + 'px';
                if (this.spacer.style.height !== spacerHeight) {
                    this.spacer.style.height = spacerHeight;
                }
            }
        },

        refreshMeasurements: function () {
            if (!this.header) return;

            this.headerOffset = this.readHeaderOffset();
            this.productSolidThreshold = this.readProductThreshold(this.headerOffset);
            this.hero = document.querySelector('.hero-kith');

            this.writeHeaderOffset(this.headerOffset);
            this.setupHeroObserver();
            this.updateSolidState();
        },

        setupHeroObserver: function () {
            if (this.heroObserver) {
                this.heroObserver.disconnect();
                this.heroObserver = null;
            }

            if (!this.hero) {
                this.heroInView = true;
                this.useScrollPosition = true;
                return;
            }

            this.useScrollPosition = false;

            if (!('IntersectionObserver' in window)) {
                this.heroInView = this.hero.getBoundingClientRect().bottom > this.headerOffset;
                return;
            }

            this.heroInView = this.hero.getBoundingClientRect().bottom > this.headerOffset;

            var self = this;
            this.heroObserver = new IntersectionObserver(function (entries) {
                var entry = entries[0];
                var nextHeroInView = !!(entry && entry.isIntersecting && entry.intersectionRatio > 0);

                if (nextHeroInView === self.heroInView) return;

                self.heroInView = nextHeroInView;
                self.updateSolidState();
            }, {
                threshold: [0, 0.01],
                rootMargin: '-' + this.headerOffset + 'px 0px 0px 0px'
            });

            this.heroObserver.observe(this.hero);
        },

        setHiddenState: function (shouldHide) {
            if (this.isHidden === shouldHide) return;

            this.isHidden = shouldHide;
            this.header.classList.toggle('is-hidden', shouldHide);

            /* Mirror the shy state onto <html> so sticky toolbars can follow the
               header instead of guessing. `position: sticky` resolves `top`
               against the viewport, not against the header, so a bar pinned at
               a constant header-height leaves a dead band once the header slides
               away — the gap Joseph reported above "41 Results / Filter & Sort".
               Driving it off one CSS variable means the bar rides up to 0 when
               the header hides and back down when it returns, with no scroll
               handler of its own. This runs only on an actual state change, so
               it costs one class toggle per shy transition, not per frame. */
            document.documentElement.classList.toggle('wcwy-header-shy', shouldHide);
        },

        applySolidState: function (shouldBeSolid) {
            if (this._hasAppliedSolidState && this.isSolid === shouldBeSolid) {
                if (!shouldBeSolid) {
                    this.setHiddenState(false);
                }
                return;
            }

            this.isSolid = shouldBeSolid;
            this.header.classList.toggle('is-solid', shouldBeSolid);
            this.header.classList.toggle('is-scrolled', shouldBeSolid);
            this.header.classList.toggle('is-transparent', !shouldBeSolid);
            document.body.classList.toggle('has-solid-header', shouldBeSolid);

            if (!shouldBeSolid) {
                this.setHiddenState(false);
            }

            this._hasAppliedSolidState = true;
        },

        updateSolidState: function () {
            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
            var shouldBeSolid;

            /* The product page decides "solid" from the gallery height rather
               than a hero observer, but that is the only thing special about
               it. It used to also pin the header open — applySolidState already
               un-hides whenever the header goes transparent, so the extra
               setHiddenState(false) here did nothing but cancel the shy
               behaviour handleScroll had just applied. */
            if (this.isProductPage) {
                this.applySolidState(scrollTop > this.productSolidThreshold);
                return;
            }

            if (this.useScrollPosition) {
                shouldBeSolid = scrollTop > 20;
            } else {
                shouldBeSolid = !this.heroInView;
            }

            this.applySolidState(shouldBeSolid);
        },

        handleScroll: function () {
            if (!this.header) return;

            var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
            var diff = scrollTop - this.lastScrollTop;

            if (this.isProductPage || this.useScrollPosition) {
                this.updateSolidState();
            }

            if (Math.abs(diff) < this.scrollDelta) {
                this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
                return;
            }

            if (diff > 0 && scrollTop > this.hideThreshold && this.isSolid) {
                this.setHiddenState(true);
            } else {
                this.setHiddenState(false);
            }

            this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
        },

        toggleSearch: function () {
            if (!this.searchDropdown) return;

            if (this.searchDropdown.style.display === 'none' || !this.searchDropdown.style.display) {
                this.openSearch();
            } else {
                this.closeSearch();
            }
        },

        openSearch: function () {
            if (!this.searchDropdown) return;

            this.searchDropdown.style.display = 'block';
            var input = this.searchDropdown.querySelector('input');
            if (!input) return;

            window.setTimeout(function () {
                input.focus();
            }, 100);
        },

        closeSearch: function () {
            if (!this.searchDropdown) return;
            this.searchDropdown.style.display = 'none';
        }
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            kithHeader.init();
        });
    } else {
        kithHeader.init();
    }
})();

// SAM.STYLE Drawer
(function () {
    'use strict';

    /* This file is three separate IIFEs. These helpers exist in the first one
       too — they are duplicated here on purpose, because a function declared in
       the header IIFE is NOT in scope inside this one. Getting that wrong threw
       a ReferenceError before the is-open classes were applied, which stopped
       the SAM.STYLE drawer opening at all. Do not "deduplicate" these by
       deleting this copy; hoist them to a shared module if it ever matters. */
    function wcwyDrawerTiming() {
        if (window.WCWYDrawerController && window.WCWYDrawerController.timing) {
            return window.WCWYDrawerController.timing();
        }
        return { open: 360, close: 260, openSettle: 380, closeFallback: 340 };
    }

    function wcwyAfterPaint(fn) {
        if (window.WCWYDrawerController && window.WCWYDrawerController.afterPaint) {
            return window.WCWYDrawerController.afterPaint(fn);
        }
        return window.requestAnimationFrame(function () {
            window.requestAnimationFrame(fn);
        });
    }

    function wcwySetDrawerInert(node, shouldBeInert) {
        if (!node) return;
        if (window.WCWYDrawerController && window.WCWYDrawerController.setInert) {
            window.WCWYDrawerController.setInert(node, shouldBeInert);
            return;
        }
        node.inert = shouldBeInert;
        if (shouldBeInert) {
            node.setAttribute('inert', '');
        } else {
            node.removeAttribute('inert');
        }
    }

    var samStyleDrawer = {
        drawer: null,
        overlay: null,
        shopLink: null,
        closeBtn: null,
        isOpen: false,
        _bound: false,
        _editorBound: false,
        _instantBound: false,
        _instantReadyBound: false,
        _swipeBound: false,
        _pendingOpenFrame: null,
        _closeTimer: null,
        _closeTransitionHandler: null,

        hydrateImages: function () {
            if (!this.drawer) return;

            var images = this.drawer.querySelectorAll('.wcwy-deferred-img[data-src], .wcwy-deferred-img[data-srcset]');
            for (var i = 0; i < images.length; i++) {
                var img = images[i];
                var src = img.getAttribute('data-src');
                var srcset = img.getAttribute('data-srcset');
                var sizes = img.getAttribute('data-sizes');

                if (sizes) {
                    img.setAttribute('sizes', sizes);
                    img.removeAttribute('data-sizes');
                }

                if (srcset) {
                    img.setAttribute('srcset', srcset);
                    img.removeAttribute('data-srcset');
                }

                if (src) {
                    img.setAttribute('src', src);
                    img.removeAttribute('data-src');
                }

                img.classList.remove('wcwy-deferred-img');
            }
        },

        init: function () {
            this.drawer = document.querySelector('[data-samstyle-drawer]');
            this.overlay = document.querySelector('[data-samstyle-overlay]');
            this.shopLink = document.querySelector('.kith-header__shop-link');
            this.closeBtn = document.querySelector('[data-samstyle-close]');

            if (!this.drawer || !this.shopLink) return;
            if (document.body) {
                if (this.overlay && this.overlay.parentNode !== document.body) {
                    document.body.appendChild(this.overlay);
                }
                if (this.drawer.parentNode !== document.body) {
                    document.body.appendChild(this.drawer);
                }
            }
            this.shopLink.setAttribute('aria-haspopup', 'dialog');
            this.shopLink.setAttribute('aria-expanded', this.isOpen ? 'true' : 'false');

            if (window.WCWYDrawerController) {
                var controller = this;
                window.WCWYDrawerController.register('samstyle', {
                    drawer: this.drawer,
                    overlay: this.overlay,
                    focusTarget: '[data-samstyle-close]',
                    isOpen: function () {
                        return controller.drawer && controller.drawer.classList.contains('is-open');
                    },
                    close: function () {
                        controller.close();
                    }
                });
            }

            this.bindEvents();
            this.primeDrawer();
        },

        /**
         * Lay the drawer out once, at idle after load, so the first open runs a
         * transform and nothing else. This drawer had it worst: it was revealed
         * by .is-mounted one frame before .is-open, and one frame cannot lay out
         * a column of product tiles.
         *
         * Deferred images are hydrated here too. hydrateImages already ran on
         * trigger hover, but hover is not a signal that exists on touch, which
         * is where the abruptness was most visible — there the decode landed
         * inside the transform every time.
         */
        primeDrawer: function () {
            if (!this.drawer || !this.overlay) return;
            /* Keyed to the element, not to a flag on this object: the theme
               editor re-runs init() with a freshly rendered drawer, and a
               boolean guard would leave that new node unprimed forever. */
            if (this.drawer.dataset.samstylePrimed) return;

            var controller = window.WCWYDrawerController;
            if (!controller || !controller.prime) return;

            this.drawer.dataset.samstylePrimed = 'true';
            if (!this.isOpen) wcwySetDrawerInert(this.drawer, true);

            controller.prime(function () {
                var self = samStyleDrawer;
                if (!self.drawer || !self.overlay) return;
                self.drawer.classList.add('is-primed');
                self.overlay.classList.add('is-primed');
                self.hydrateImages();
                /* Force the layout inside the idle callback rather than leaving
                   it for whichever frame touches the drawer next. */
                self.drawer.offsetHeight;
            });
        },

        bindEvents: function () {
            var self = this;

            if (this.shopLink && !this.shopLink.dataset.samstyleBound) {
                this.shopLink.dataset.samstyleBound = 'true';
                this.shopLink.addEventListener('click', function (event) {
                    event.preventDefault();
                    self.open();
                });

                // Start the drawer's deferred images on hover/focus rather than
                // at open time. Setting src during open means images decode and
                // paint into the drawer's compositor layer while it is sliding,
                // which repaints the layer mid-transform. Hovering the trigger
                // is a reliable intent signal and buys those decodes for free.
                var warm = function () { self.hydrateImages(); };
                self.shopLink.addEventListener('pointerenter', warm, { once: true, passive: true });
                self.shopLink.addEventListener('focus', warm, { once: true });
            }

            if (this.closeBtn && !this.closeBtn.dataset.samstyleBound) {
                this.closeBtn.dataset.samstyleBound = 'true';
                this.closeBtn.addEventListener('click', function (event) {
                    event.preventDefault();
                    self.close();
                });
            }

            if (this.overlay && !this.overlay.dataset.samstyleBound) {
                this.overlay.dataset.samstyleBound = 'true';
                this.overlay.addEventListener('click', function () {
                    self.close();
                });
            }

            if (!this._bound) {
                document.addEventListener('keydown', function (event) {
                    if (event.key === 'Escape' && self.isOpen) {
                        self.close();
                    }
                });

                this._bound = true;
            }

            if (!this._editorBound && typeof Shopify !== 'undefined' && Shopify.designMode) {
                document.addEventListener('shopify:section:load', function () {
                    self.init();
                });
                document.addEventListener('shopify:section:select', function (e) {
                    if (e.detail && e.detail.sectionId && e.detail.sectionId.indexOf('samstyle') > -1) {
                        self.open();
                    }
                });
                document.addEventListener('shopify:section:deselect', function (e) {
                    if (e.detail && e.detail.sectionId && e.detail.sectionId.indexOf('samstyle') > -1) {
                        self.close();
                    }
                });
                document.addEventListener('shopify:block:select', function (e) {
                    if (e.detail && e.detail.sectionId && e.detail.sectionId.indexOf('samstyle') > -1) {
                        self.open();
                    }
                });
                this._editorBound = true;
            }

        },

        bindInstantClick: function () {
            var self = this;
            if (this._instantBound || typeof InstantClick === 'undefined') return;

            InstantClick.on('change', function () {
                if (self.isOpen) {
                    self.close();
                }
                self.init();
            });

            this._instantBound = true;
        },

        open: function () {
            if (!this.drawer || !this.overlay) return;
            if (this.isOpen) return;

            if (this._closeTransitionHandler) {
                this.drawer.removeEventListener('transitionend', this._closeTransitionHandler);
                this._closeTransitionHandler = null;
            }
            window.clearTimeout(this._closeTimer);
            if (this._pendingOpenFrame) {
                window.cancelAnimationFrame(this._pendingOpenFrame);
                this._pendingOpenFrame = null;
            }

            this.hydrateImages();

            this.isOpen = true;
            this.drawer.classList.add('is-mounted');
            this.overlay.classList.add('is-mounted');
            wcwySetDrawerInert(this.drawer, false);
            this.drawer.setAttribute('aria-hidden', 'false');
            this.overlay.setAttribute('aria-hidden', 'false');
            this.shopLink.setAttribute('aria-expanded', 'true');
            if (window.WCWYDrawerController) {
                window.WCWYDrawerController.open('samstyle');
            } else {
                document.documentElement.style.overflow = 'hidden';
                document.body.style.overflow = 'hidden';
            }
            document.body.classList.add('samstyle-drawer-open');

            // Pay the mount layout cost now, while nothing is animating, then let
            // the browser paint a clean frame before the slide starts.
            this.drawer.offsetHeight;

            this._pendingOpenFrame = wcwyAfterPaint(function () {
                if (!samStyleDrawer.drawer || !samStyleDrawer.overlay) return;
                samStyleDrawer.drawer.classList.add('is-open');
                samStyleDrawer.overlay.classList.add('is-open');
                if (samStyleDrawer.closeBtn) {
                    window.setTimeout(function () {
                        samStyleDrawer.closeBtn.focus({ preventScroll: true });
                    }, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : wcwyDrawerTiming().openSettle);
                }
                samStyleDrawer._pendingOpenFrame = null;
            });

            this._bindSwipeClose();
        },

        close: function () {
            if (!this.drawer || !this.overlay) return;
            if (!this.isOpen && !this.drawer.classList.contains('is-mounted')) return;
            if (this._pendingOpenFrame) {
                window.cancelAnimationFrame(this._pendingOpenFrame);
                this._pendingOpenFrame = null;
            }

            this.isOpen = false;
            this.drawer.classList.remove('is-open');
            this.overlay.classList.remove('is-open');
            this.drawer.setAttribute('aria-hidden', 'true');
            this.overlay.setAttribute('aria-hidden', 'true');
            this.shopLink.setAttribute('aria-expanded', 'false');
            document.body.classList.remove('samstyle-drawer-open');
            if (window.WCWYDrawerController) {
                window.WCWYDrawerController.close('samstyle');
            } else {
                document.documentElement.style.overflow = '';
                document.body.style.overflow = '';
            }

            if (this._closeTransitionHandler) {
                this.drawer.removeEventListener('transitionend', this._closeTransitionHandler);
                this._closeTransitionHandler = null;
            }
            window.clearTimeout(this._closeTimer);

            /* Drops the compositor hint only. is-primed deliberately survives —
               re-hiding the subtree on close is what made every open after the
               first re-pay part of the mount cost. */
            var finalizeClose = function () {
                samStyleDrawer.drawer.classList.remove('is-mounted');
                samStyleDrawer.overlay.classList.remove('is-mounted');
                wcwySetDrawerInert(samStyleDrawer.drawer, true);
            };

            if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
                finalizeClose();
                return;
            }

            this._closeTransitionHandler = function (event) {
                if (event.target !== samStyleDrawer.drawer || event.propertyName !== 'transform') return;
                samStyleDrawer.drawer.removeEventListener('transitionend', samStyleDrawer._closeTransitionHandler);
                samStyleDrawer._closeTransitionHandler = null;
                window.clearTimeout(samStyleDrawer._closeTimer);
                finalizeClose();
            };
            this.drawer.addEventListener('transitionend', this._closeTransitionHandler);
            this._closeTimer = window.setTimeout(function () {
                if (samStyleDrawer._closeTransitionHandler) {
                    samStyleDrawer.drawer.removeEventListener('transitionend', samStyleDrawer._closeTransitionHandler);
                    samStyleDrawer._closeTransitionHandler = null;
                }
                finalizeClose();
            }, wcwyDrawerTiming().closeFallback);
        },

        _bindSwipeClose: function () {
            if (this._swipeBound || !this.drawer) return;

            var self = this;
            var startX = 0;
            var startY = 0;

            this.drawer.addEventListener('touchstart', function (e) {
                startX = e.touches[0].clientX;
                startY = e.touches[0].clientY;
            }, { passive: true });

            this.drawer.addEventListener('touchend', function (e) {
                var dx = e.changedTouches[0].clientX - startX;
                var dy = e.changedTouches[0].clientY - startY;
                // Left swipe: horizontal-dominant and at least 60px
                if (dx < -60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
                    self.close();
                }
            }, { passive: true });

            this._swipeBound = true;
        }
    };

    // Defer header initialization to avoid blocking main thread
    function initHeaderDeferred() {
        samStyleDrawer.init();
    }

    if ('requestIdleCallback' in window) {
        requestIdleCallback(initHeaderDeferred, { timeout: 2000 });
    } else {
        // Fallback for browsers without requestIdleCallback
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', function () {
                window.setTimeout(initHeaderDeferred, 150);
            });
        } else {
            window.setTimeout(initHeaderDeferred, 150);
        }
    }
})();

// SAM.STYLE Hero Carousel
(function () {
    'use strict';

    var INTERVAL = 4500;

    function SSPCarousel(el) {
        this.hero = el;
        this.track = el.querySelector('[data-ssp-track]');
        this.slides = el.querySelectorAll('[data-ssp-slide]');
        this.dots = el.querySelectorAll('[data-ssp-dot]');
        this.prevBtn = el.querySelector('[data-ssp-prev]');
        this.nextBtn = el.querySelector('[data-ssp-next]');
        this.total = this.slides.length;
        this.current = 0;
        this.timer = null;
        this.paused = false;

        if (!this.track || this.total < 2) return;

        this._bindEvents();
        this._startAuto();
    }

    SSPCarousel.prototype._goTo = function (index) {
        this.current = ((index % this.total) + this.total) % this.total;
        this.track.style.transform = 'translateX(-' + (this.current * 100) + '%)';
        for (var i = 0; i < this.dots.length; i++) {
            this.dots[i].classList.toggle('is-active', i === this.current);
        }
    };

    SSPCarousel.prototype._next = function () {
        this._goTo(this.current + 1);
    };

    SSPCarousel.prototype._prev = function () {
        this._goTo(this.current - 1);
    };

    SSPCarousel.prototype._startAuto = function () {
        var self = this;
        this.timer = setInterval(function () {
            if (!self.paused) self._next();
        }, INTERVAL);
    };

    SSPCarousel.prototype._stopAuto = function () {
        clearInterval(this.timer);
        this.timer = null;
    };

    SSPCarousel.prototype._bindEvents = function () {
        var self = this;

        this.hero.addEventListener('mouseenter', function () { self.paused = true; });
        this.hero.addEventListener('mouseleave', function () { self.paused = false; });

        this.hero.addEventListener('touchstart', function () { self.paused = true; }, { passive: true });
        this.hero.addEventListener('touchend', function () { self.paused = false; }, { passive: true });

        if (this.prevBtn) {
            this.prevBtn.addEventListener('click', function () {
                self._stopAuto();
                self._prev();
                self._startAuto();
            });
        }

        if (this.nextBtn) {
            this.nextBtn.addEventListener('click', function () {
                self._stopAuto();
                self._next();
                self._startAuto();
            });
        }

        for (var i = 0; i < this.dots.length; i++) {
            (function (idx) {
                self.dots[idx].addEventListener('click', function () {
                    self._stopAuto();
                    self._goTo(idx);
                    self._startAuto();
                });
            })(i);
        }
    };

    function initSSPCarousels() {
        var heroes = document.querySelectorAll('[data-ssp-hero]');
        for (var i = 0; i < heroes.length; i++) {
            var el = heroes[i];
            if (!el._sspCarousel) {
                el._sspCarousel = new SSPCarousel(el);
            }
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSSPCarousels);
    } else {
        initSSPCarousels();
    }

    document.addEventListener('shopify:section:load', function () {
        var heroes = document.querySelectorAll('[data-ssp-hero]');
        for (var i = 0; i < heroes.length; i++) {
            var carousel = heroes[i]._sspCarousel;
            if (carousel) {
                carousel._stopAuto();
                delete heroes[i]._sspCarousel;
            }
        }
        initSSPCarousels();
    });
})();
